export default __webpack_public_path__ + "static/media/running-101-gif.590ba0b2.gif";